// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"72a91862","456":"98c4d450","595":"bc3f1fed","718":"cd84724f","764":"b1e8a9c4","951":"c4349ac6"}[chunkId] + ".chunk.css";
};